import { createFileRoute } from '@tanstack/react-router'
import { QrProfilePage } from '@/features/qr-profile/qr-profile-page'

export const Route = createFileRoute('/_authenticated/profile/qr-code/')({
  component: QrProfilePage,
})
